





import {Component, Prop, Vue} from 'vue-property-decorator'

import {IAgencyCostImperial} from "@/modules/agencyCost/interfaces/agencyCost";
import BaseAgencyCostPlot from "@/modules/agencyCost/views/components/BaseAgencyCostPlot.vue";
import {
  getTotalActivityCost,
  getTotalActivityNpv,
  prepareScenarioForAnalysis
} from "@/modules/agencyCost/lib/calculations/activity";
import {createSteppedCumulativeCost} from "@/modules/agencyCost/lib/calculations/plot";


@Component({
  components: {
    BaseAgencyCostPlot
  },
})
export default class AgencyCostPlot extends Vue {
  @Prop() scenariosImperial!: IAgencyCostImperial[];
  @Prop({default: false}) showNpv!: boolean;

  get chartData() {
    const that = this;
    return {
      // labels: this.scenariosImperial.map(s => s.name),
      datasets: function () {

        const seriesList: any[] = [];

        that.scenariosImperial.map(s => {
          // Straight cost series
          seriesList.push({
            label: s.name,
            lineTension: 0,
            data: function () {

              const base = s.activities.map(A => {
                return {
                  x: A.yearsAfterStart + (s.startYear || 0),
                  y: getTotalActivityCost(A)
                }
              });

              return createSteppedCumulativeCost(base);
            }()
          });

          if (that.showNpv) {
            // Net present value
            seriesList.push({
              label: s.name + ' NPV',
              lineTension: 0,
              data: function () {
                const npv = s.activities.map(A => {
                  return {
                    x: A.yearsAfterStart + (s.startYear || 0),
                    y: getTotalActivityNpv(A, s.discountRate_pct || 0)
                  }
                });

                return createSteppedCumulativeCost(npv);
              }()
            })
          }

        });

        return seriesList
      }()
    }
  }

  get style() {
    return {
      position: 'relative',
      height: null,
      width: null,
    }
  }

  created() {
    this.scenariosImperial.forEach(s => prepareScenarioForAnalysis(s))
  }

}

